<template>
  <div class="">
      <a-drawer title="Form Builder" :width="900" placement="right" @close="formBuilderClose" :visible="formBuilderVisible">
          <div v-if="formBuilderType == 'addGroup' || formBuilderType == 'editGroup'">
              <base-input label="Group Name">
                  <a-input type="text" v-model="group.name"/>
              </base-input>
              <base-input label="Group Description">
                  <a-textarea :autoSize="{ minRows: 6, maxRows: 10 }" v-model="group.description"/>
              </base-input>
              <base-input label="Sequence">
                  <a-input type="number" v-model="group.sequence"/>
              </base-input>
          </div>
          <div v-if="formBuilderType == 'addComponents' || formBuilderType == 'editComponent'" >
              <base-input label="Field Name">
                  <a-select @select="setField" style="width: 100%" placeholder="Select field" v-model="component.code" :filterOption="filterOption" showSearch>
                      <a-select-option v-for="field in modelAttributes" :key="field.field_name" :value="field.field_name">{{field.label}}</a-select-option>
                  </a-select>
              </base-input>
              <base-input label="Input Type">
                  <a-select style="width: 100%" placeholder="Select input type" v-model="component.type" :disabled="fieldDetailsDisabled">
                      <a-select-option v-for="inputType in formInputTypes" :key="inputType" :value="inputType">{{inputType}}</a-select-option>
                  </a-select>
              </base-input>
              <div v-if="component.type != null">
                  <base-input label="Required">
                      <br/>
                    <a-switch v-model="component.required" :disabled="fieldDetailsDisabled"/>
                  </base-input>
                  <base-input label="Label">
                      <a-input type="text" v-model="component.label"/>
                  </base-input>
                  <base-input label="Description">
                      <a-textarea :autoSize="{ minRows: 3, maxRows: 6 }" v-model="component.description"/>
                  </base-input>
                  <base-input label="Default Value">
                      <a-input type="text" v-model="component.defaultValue" :disabled="fieldDetailsDisabled"/>
                  </base-input>
                  <base-input v-if="group.terminalSettings != undefined && fieldDetailsDisabled == false" label="Conditions">
                      <button class="btn btn-sm btn-warning float-right" @click="handleAdd('conditions')"> + Add Condition</button> <br/><br/>
                      <a-table :columns="conditionColumns" :dataSource="component.conditions" bordered :key="tableConditionKey">
                          <template
                            v-for="col in ['code', 'operator', 'value']"
                            :slot="col"
                            slot-scope="text, record"
                          >
                            <div :key="col">
                              <div v-if="col == 'code'">
                                  <a-select v-if="record.editable" style="width: 100%" placeholder="Select field" @select="e => handleChange(e, record.key, col, 'conditions')">
                                      <a-select-option v-for="terminalSetting in group.terminalSettings" :key="terminalSetting.key" :value="terminalSetting.code">{{terminalSetting.label}}</a-select-option>
                                  </a-select>
                                  <template v-else>{{text}}</template>
                              </div>
                              <div v-if="col == 'operator'">
                                  <a-select v-if="record.editable" style="width: 100%" placeholder="Select operation" @select="e => handleChange(e, record.key, col, 'conditions')">
                                      <a-select-option v-for="operation in operations" :key="operation" :value="operation">{{operation}}</a-select-option>
                                  </a-select>
                                  <template v-else>{{text}}</template>
                              </div>
                              <div v-if="col == 'value'">
                                    <input
                                    v-if="record.editable"
                                    style="margin: -5px 0"
                                    :value="text"
                                    @change="e => handleChange(e.target.value, record.key, col, 'conditions')"
                                  />
                                  <template v-else>{{text}}</template>
                              </div>
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, 'conditions')">Save</a>
                              </span>
                              <span v-else>
                                <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key, 'conditions')">Edit</a>
                                <a-popconfirm title="Are you sure you want to delete this condition?" @confirm="() => deleteField(record, 'conditions')">
                                  <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                                </a-popconfirm>
                              </span>
                            </div>
                          </template>
                      </a-table>
                  </base-input>
              </div>
              <div v-if="component.type == 'cascader'">
                  <base-input label="Endpoint">
                      <a-input type="text" v-model="component.endpoint" :disabled="fieldDetailsDisabled"/>
                  </base-input>
              </div>
              <div v-if="component.type == 'select' || component.type == 'multiple_select' || component.type == 'radio'">
                  <base-input label="Option Source">
                      <br/>
                      <a-radio-group v-model="component.selectStyle" @change.prevent="reviewOptions" :disabled="fieldDetailsDisabled">
                          <a-radio value="1" :key="1"> Manual</a-radio>
                          <a-radio value="2" :key="2"> Define endpoint</a-radio>
                      </a-radio-group>
                  </base-input>
                  <div v-if="component.selectStyle == 1">
                      <button class="btn btn-sm btn-warning float-right" @click="handleAdd('options')"> + Add Option</button> <br/><br/>
                      <a-table :columns="optionColumns" :dataSource="component.options" bordered :key="tableOptionKey">
                          <template
                            v-for="col in ['id', 'name']"
                            :slot="col"
                            slot-scope="text, record"
                          >
                            <div :key="col">
                              <input
                                v-if="record.editable"
                                style="margin: -5px 0"
                                :value="text"
                                @change="e => handleChange(e.target.value, record.key, col, 'options')"
                              />
                              <template v-else>{{text}}</template
                              >
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, 'options')">Save</a>
                              </span>
                              <span v-else>
                                <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key, 'options')">Edit</a>
                                <a-popconfirm title="Are you sure you want to delete this option?" @confirm="() => deleteField(record, 'options')">
                                  <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                                </a-popconfirm>
                              </span>
                            </div>
                          </template>
                      </a-table>
                  </div>
                  <base-input v-if="component.selectStyle == 2" label="Endpoint">
                      <a-input type="text" v-model="component.endpoint" :disabled="fieldDetailsDisabled"/>
                  </base-input>
              </div>
          </div>
          <div v-if="formBuilderType == 'addGroup' || formBuilderType == 'editGroup'" :style="stickyButton">
              <button v-if="formBuilderType == 'addGroup'" style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="addGroup"> Save </button>
              <button v-else style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="saveGroup(group)"> Save </button>
              <button style="margin-left: 8px" class="btn btn-sm btn-danegr" @click.prevent="formBuilderClose"> Cancel </button>
          </div>
          <div v-else :style="stickyButton">
              <button v-if="formBuilderType == 'addComponents'" style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="addComponent"> Save </button>
              <button v-else style="margin-left: 8px" class="btn btn-sm btn-primary" @click.prevent="saveComponent(component)"> Save </button>
              <button style="margin-left: 8px" class="btn btn-sm btn-danegr" @click.prevent="formBuilderClose"> Cancel </button>
          </div>
      </a-drawer>

      <a-drawer :title="configurationTitle" :width="1000" placement="right" @close="onClose" :visible="visible" :key="configKey">
          <div>
            <a-steps :current="current">
              <a-step v-for="item in steps" :key="item.title" :title="item.title" />
              <!-- <h6 class="heading-small text-muted mb-4">{{item.description}}</h6> -->
            </a-steps>
            <div class="steps-content">
                <br/>
                <!-- {{ _.pluralize(_.snakeCase(selectedModule.name)) }} -->
                <div v-if="current == 0">
                  <button class="btn btn-sm btn-warning float-right" @click="handleAdd(null)"> + Add Custom Field</button> <br/><br/>
                  <a-table :columns="columns" :dataSource="dataSource" :pagination="dataSourcepagination" bordered>
                      <template
                        v-for="col in ['code', 'name', 'data_type']"
                        :slot="col"
                        slot-scope="text, record"
                      >
                        <div :key="col" v-if="col == 'data_type'">
                          <a-select v-if="record.editable" style="width: 100%" placeholder="Select input type" @select="e => handleChange(e, record.key, col)">
                            <a-select-option v-for="inputType in formDataTypes" :key="inputType" :value="inputType">{{inputType}}</a-select-option>
                          </a-select>
                          <template v-else>{{text}}</template
                          >
                        </div>

                        <div :key="col" v-else>
                          <input
                            v-if="record.editable"
                            style="margin: -5px 0"
                            :value="text"
                            @change="e => handleChange(e.target.value, record.key, col)"
                          />
                          <template v-else>{{text}}</template
                          >
                        </div>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations">
                          <span v-if="record.editable">
                            <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key, null)">Save</a>
                            <!-- <a style="color: white;" class="btn btn-sm btn-danger" @click="() => cancel(record.key, null)">Cancel</a> -->
                          </span>
                          <span v-else>
                            <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key)">Edit</a>
                            <a-popconfirm title="This will also delete coresponding form component. Are you sure you want to delete this custom field?" @confirm="() => deleteField(record, null)">
                              <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                            </a-popconfirm>
                          </span>
                        </div>
                      </template>
                  </a-table>
                </div>
                <div v-if="current == 1">
                  <h6 class="heading-small text-muted mb-4">FORM MODE</h6>
                  <a-radio-group v-model="customFormMode">
                    <a-radio :value="1" :key="1" :style="radioStyle2">
                        <b>No customization</b>
                        <p style="padding-left: 25px;"><small>This will use the system defined form.</small></p>
                      </a-radio><br/>
                      <a-radio :value="2" :key="2" :style="radioStyle2">
                        <b>Override</b>
                        <p style="padding-left: 25px;"><small>This will completely override the system defined form.</small></p>
                      </a-radio><br/>
                      <a-radio :value="3" :key="3" :style="radioStyle2">
                        <b>Append</b>
                        <p style="padding-left: 25px;"><small>This will simply add components to the system defined form.</small></p>
                      </a-radio>
                  </a-radio-group>

                  <div v-if="customFormMode > 1">
                    <h6 class="heading-small text-muted mb-4">CUSTOM FORM STYLE</h6>
                      <a-select style="width: 100%" placeholder="Select form grouping" v-model="formGroupStyle">
                        <a-select-option v-for="formGroup in formGroups" :key="formGroup.id" :value="formGroup.id">{{formGroup.name}}</a-select-option>
                      </a-select>
                    <!-- <a-radio-group v-model="customFormMode">
                      <a-radio v-for="option in formGroups" :style="radioStyle2" :value="option.id" :key="option.id">
                        {{option.name}}
                      </a-radio>
                    </a-radio-group> -->
                  </div>

                  <!-- <div class="col-md-12">
                    <base-input v-if="customFormMode > 1" label="Form Grouping Style">
                        <a-select style="width: 100%" placeholder="Select form grouping" v-model="formGroupStyle">
                            <a-select-option v-for="formGroup in formGroups" :key="formGroup.id" :value="formGroup.id">{{formGroup.name}}</a-select-option>
                        </a-select>
                    </base-input>
                  </div> -->

                </div>
                <div v-if="current == 2 && customFormMode == 1">
                  <br/><br/>
                  <center> <h6 class="heading-small text-muted mb-4"> Not applicable. Will use system defined form. </h6> </center>
                </div>

                <div v-if="current == 2 && customFormMode > 1">
                  <h6 class="heading-small text-muted mb-4">FORM BUILDER</h6>

                  <div v-if="customFormMode == 2">
                    <h5>System Required Fields</h5>
                    <small>Please make sure that all system required fields are included on your custom form.</small> <br/><br/>
                    <template v-for="(field, index) in requiredFields">
                      <a-tag v-if="existingConfig.includes(field)" :key="index" color="green">{{field}}</a-tag>
                      <a-tag v-else :key="index" color="red">{{field}}</a-tag>
                    </template>
                  </div>

                  <hr class="my-3" />

                  <button v-if="groups.length > 0 && viewMode == null" class="btn btn-sm btn-primary float-right" @click.prevent="viewMode = 'preview'"> Preview Form </button>
                  <button v-if="formGroupStyle != null && viewMode == null" class="btn btn-sm btn-warning float-right" @click.prevent="showFormBuilder('addGroup')"> + Add Group </button>
                  <button v-if="groups.length > 0 && viewMode != null" class="btn btn-sm btn-primary float-right" @click.prevent="viewMode = null"> Show Editor </button> <br/><br/>

                  <!-- <hr/>
                      <small>{{ { mode: formGroupStyle, groups: groups } }}</small>
                  <hr/> -->

                  <div v-if="viewMode == 'preview'">
                    <dynamic-form :convertedJson="{mode: formGroupStyle, groups: groups}"></dynamic-form>
                  </div>

                  <div v-else>
                    <div v-for="group in groups" :key="group.key">
                          <a-card :title="group.name" >
                              <a-dropdown slot="extra">
                                  <a class="ant-dropdown-link">
                                      <span class="fa fa-ellipsis-v"></span>
                                  </a>
                                  <a-menu slot="overlay">
                                      <a-menu-item key=1>
                                          <a @click.prevent="showFormBuilder('editGroup', group)">Edit</a>
                                      </a-menu-item>
                                      <a-menu-item key=2>
                                          <a @click.prevent="showFormBuilder('addComponents', group)">Add Components</a>
                                      </a-menu-item>
                                      <a-menu-item key=3>
                                            <a-popconfirm title="Are you sure you want to delete this form group?" @confirm="() => deleteGroup({group: group} )">
                                              <a>Delete</a>
                                            </a-popconfirm>
                                        </a-menu-item>
                                  </a-menu>
                              </a-dropdown>

                              <h6 class="heading-small text-muted mb-4">Form Components</h6>
                              <a-table :columns="componentColumns" :dataSource="group.terminalSettings" :key="componentsTableKey" bordered>
                                <a-dropdown slot="actions" slot-scope="text, record">
                                    <a class="ant-dropdown-link">
                                        <span class="fa fa-ellipsis-v"></span>
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item key=1>
                                            <a @click.prevent="showFormBuilder('editComponent', {component: record, group: group} )">Edit</a>
                                        </a-menu-item>
                                        <a-menu-item key=2>
                                            <a-popconfirm title="Are you sure you want to delete this component?" @confirm="() => deleteComponent({component: record, group: group} )">
                                              <a>Delete</a>
                                            </a-popconfirm>
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>

                              </a-table>

                          </a-card>
                          <br/> <br/>

                    </div>
                  </div>

                </div>
                <br/>
                <br/>
            </div>
            <div class="steps-action float-right">
              <div :style="stickyButton">
                      <button v-if="current>0" style="margin-left: 8px" @click="current--" class="btn btn-sm btn-primary">
                        Previous
                      </button>
                      <button v-if="current < steps.length - 1" type="primary" @click="current++" class="btn btn-sm btn-primary">
                        Next
                      </button>
                      <button
                        class="btn btn-sm btn-success"
                        v-if="current == steps.length - 1"
                        type="primary"
                        @click="saveAccSystemModule"
                      >
                        Done
                      </button>
              </div>

            </div>
          </div>
      </a-drawer>

      <div class="row">
          <div class="col">
                  <div class="card mb-3">
                    <div class="row no-gutters">
                      <div class="col-md-6" style="border-right: 1px solid #e0e0e0">
                        <div class="card-body">
                          <div class="row">
                              <div class="col-md-6 no-gutters"><h2 class="card-title">Categories</h2></div>

                              <div class="col-md-12 no-gutters">
                                <base-input label="Account Selection">
                                  <a-select style="width: 100%"
                                            placeholder="Select an Account"
                                            v-model="selectedAccount">
                                    <a-select-option v-for="account in accounts"
                                                     :key="account"
                                                     :value="account.id">
                                      {{ account.account_name }}
                                    </a-select-option>
                                  </a-select>
                                </base-input>
                              </div>

                              <div class="col-md-12 no-gutters">
                                  <small>Please select a module category for configuration.</small> <br/><br/>

                                  <div v-if="checkedCategories.length > 0" class="col-md-6">
                                    <a-popconfirm
                                      title="You are about to change modules configuration in your account. Do you want to proceed?"
                                      @confirm="massUpdate('smcs','enabled',1)"
                                      @cancel="cancel"
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <a class="btn btn-sm" style="color: white; border-radius: 24px; background-color: #0569FF; border:0px; width: 45%;">Enable</a>
                                    </a-popconfirm>

                                    <a-popconfirm
                                      title="You are about to change modules configuration in your account. Do you want to proceed?"
                                      @confirm="massUpdate('smcs','enabled',0)"
                                      @cancel="cancel"
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <a class="btn btn-sm btn-danger float-right" style="color: white;  border-radius: 24px; border:0px; width: 45%;">Disable</a>
                                    </a-popconfirm>

                                    <br/><br/>
                                  </div>
                              </div>
                          </div>

                          <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange" />
                          <a-tree checkable showLine :expandedKeys="expandedKeys" :defaultExpandAll="defaultExpandAll"
                            @expand="onExpand" @select="onSelect" :defaultExpandedKeys="defaultExpandedKeys"
                            @check="onCheck" :treeData="gData">
                              <template slot="title" slot-scope="{title}">
                                <span v-if="title.indexOf(searchValue) > -1">
                                  {{title.substr(0, title.indexOf(searchValue))}}
                                  <span style="color: #f50">{{searchValue}}</span>
                                  {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                                </span>
                                <span v-else>{{title}} </span>
                              </template>
                          </a-tree>

                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card-body">
                            <div class="row" v-if="selectedNode != null">
                              <div class="col-md-12"><h2 v-if="selectedNode != null" class="card-title">Modules - {{this.selectedNode.title}}</h2></div>

                              <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                                  <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                      <div class="row">
                                          <div class="col-md-3">
                                              <a-checkbox @change="onCheckAllChange" :checked="checkedValues.length == system_modules.length"/>
                                          </div>

                                          <div v-if="checkedValues.length > 0" class="col-md-9">
                                              <a-popconfirm
                                                class="float-right"
                                                title="You are about to change modules configuration in your account. Do you want to proceed?"
                                                @confirm="massUpdate('system_modules','enabled',0)"
                                                @cancel="cancel"
                                                okText="Yes"
                                                cancelText="No"
                                              >
                                                <a class="btn btn-sm btn-danger" style="color: white; border-radius: 24px; border:0px; width: 30%;">Disable</a>
                                              </a-popconfirm>
                                              &nbsp; &nbsp;
                                              <a-popconfirm
                                                class="float-right"
                                                title="You are about to change modules configuration in your account. Do you want to proceed?"
                                                @confirm="massUpdate('system_modules','enabled',1)"
                                                @cancel="cancel"
                                                okText="Yes"
                                                cancelText="No"
                                              >
                                                <a class="btn btn-sm" style="color: white; border-radius: 24px; background-color: #0569FF; border:0px; width: 30%;">Enable</a>
                                              </a-popconfirm>
                                              &nbsp; &nbsp;

                                          </div>
                                        </div>
                                  </li>

                                  <!-- {{ !selectedNode.scopedSlots.code.includes('POS-PO') }} -->
                                  <li class="list-group-item" style="font-size: 14px" v-for="system_module in system_modules" :key="system_module.id">
                                        <div class="row">
                                          <div class="col-md-6">
                                              <a-checkbox data-id="system_module.name" @change="onCheckChange(system_module.id)" :checked="checkedValues.includes(system_module.id)">{{system_module.name}}</a-checkbox>
                                              <br/>
                                          </div>
                                          <div class="col-md-6">
                                              <a v-if="!selectedNode.scopedSlots.code.includes('POS-PO')" @click.prevent="editModule('editModule', system_module)"><small class="float-right">OPTIONS</small></a>
                                          </div>
                                        </div>
                                  </li>

                              </ul>
                              <div v-else class="align-text: center;">
                                  &nbsp; &nbsp; <small> No available modules for the selected category. </small>
                              </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
          </div>
      </div>
  </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js';
import DynamicForm from '../DynamicForm.vue';
import EditableCell from '../EditableCell';
import Vue from 'vue';


let gData = []
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

let node_ret = null
const getNode = function (key, tree){
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if(node.key == key){
       node_ret = node
    } else {
        if(node.children.length > 0){
            getNode(key, node.children)
        }
    }
  }
  return node_ret;
}

import { mapState, mapActions } from 'vuex'

export default {
  components: {
      DynamicForm,
      EditableCell
  },
  mounted: async function(){
    this.gData = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/tree_view?', null)
    gData = this.gData
    generateList(gData)

    await this.getAllAccounts();
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType'])
  },
  data () {
    return {
      accounts: [],
      selectedAccount: null,

      //table columns
      componentColumns: [
          {
            title: 'Label',
            dataIndex: 'label',
            width: '40%',
            scopedSlots: { customRender: 'label' },
          },
          {
            title: 'Field Name',
            dataIndex: 'code',
            width: '40%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Type',
            dataIndex: 'type',
            width: '40%',
            scopedSlots: { customRender: 'type' },
          },
          {
            title: '',
            dataIndex: 'actions',
            scopedSlots: { customRender: 'actions' },
          },
      ],
      conditionColumns: [
          {
            title: 'Code',
            dataIndex: 'code',
            width: '25%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Operation',
            dataIndex: 'operator',
            width: '25%',
            scopedSlots: { customRender: 'operator' },
          },
          {
            title: 'Value',
            dataIndex: 'value',
            width: '25%',
            scopedSlots: { customRender: 'value' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '25%',
            scopedSlots: { customRender: 'operation' },
          },
      ],
      optionColumns: [
          {
            title: 'Option Key/ID',
            dataIndex: 'id',
            width: '40%',
            scopedSlots: { customRender: 'id' },
          },
          {
            title: 'Option Label',
            dataIndex: 'name',
            width: '40%',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'operation' },
          },
      ],
      columns: [
          {
            title: 'Field Name',
            dataIndex: 'name',
            width: '25%',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: 'Field Code',
            dataIndex: 'code',
            width: '25%',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: 'Data Type',
            dataIndex: 'data_type',
            width: '25%',
            scopedSlots: { customRender: 'data_type' },
          },
          {
            title: '',
            dataIndex: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'operation' },
          },
      ],

      //keys
      componentsTableKey: 0,
      groupCardKey: 0,
      tableConditionKey: 0,
      tableOptionKey: 0,
      componentKey: 0,

      //--- Styles ---
      radioStyle2: { display: 'block', height: '40px', lineHeight: '30px',},
      stickyButton: { position: 'absolute', left: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right'},

      existingConfig: [],
      customFormMode: 1,
      formGroupStyle: "tabs",
      configurationTitle: "Module Configuration",
      requiredFields: [],

      cacheData: [],
      completeAttributes: [],
      modelAttributes: [],
      viewMode: null,
      fieldDetailsDisabled: false,
      currentField: null,
      operations: ["NOT NULL", "IS NULL", "=", ">=", "<=", ">", "<", "IN"],
      formDataTypes: ["string", "integer", "double", "boolean", "datetime"] ,
      formInputTypes: ["text", "number", "select", "multiple_select", "boolean", "date", "time", "radio", "switch", "range", "cascader"] ,
      component: {},
      group: {name: null, description: null},
      formBuilderType: null,
      formBuilderVisible: false,

      groupsOverride: [],
      groupsAppend: [],
      groups: [],
      formGroups: [
        { id: "list", name: "List" },
        { id: "tabs", name: "Tabs" }
      ],
      dataSource: [],
      dataSourcepagination: {
        defaultCurrent: 1,
        current: 1,
        onChange: (current) => {
          this.dataSourcepagination.current = current;
        },
      },
      current: 0,
      steps: [
        {
          title: 'Custom Fields Definition',
          content: 'Define custom fields fit for your business usage.',
        },
        {
          title: 'Form Configuration',
          content: 'Configure form to be displayed on create and update of selected module.',
        },
        {
          title: 'Form Builder',
          content: 'Dynamic formatting and grouping of field components in the form.',
        },
      ],
      count: 1,
      fetching: false,
      accountOptions: [],
      licenseStats: "",
      filterStatus: "",
      selectedModule: null,
      system_modules: [],
      module:{
          name: "",
          code: "",
          reference_code: "",
          supported_rights: ""
      },
      checkedValues: [],
      checkedCategories: [],
      expandedKeys: [],
      defaultExpandedKeys: [2,4,5,6,7],
      autoExpandParent: true,
      defaultExpandAll: true,
      gData,
      visible: false,
      formId: "",
      selectedNode: null,
      selectedProfile: "system_modules",
      configKey: 0
    }
  },
  watch: {
    customFormMode: async function(){
      switch(this.customFormMode){
        case 2:
          this.groups = (this.groupsOverride == undefined || this.groupsOverride == undefined) ? [] : this.groupsOverride
          let modelEndPoint;
          if(this.selectedModule.name == "Salesman"){
            this.requiredFields =  await HTTPRequest.getRequest(this.endPoint +'salesmen/get_model_attributes?required=true', null)
          } else {
            modelEndPoint = _.pluralize(_.snakeCase(this.selectedModule.name))
            this.requiredFields =  await HTTPRequest.getRequest(this.endPoint + modelEndPoint + '/get_model_attributes?required=true', null)
          }

          break;
        case 3:
          this.groups = (this.groupsAppend == undefined || this.groupsAppend == undefined) ? [] : this.groupsAppend
          break;
      }
      this.refreshDataSet()
    }
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters']),

    getAllAccounts: async function() {
      // Get all Valid and Active accounts
      let accounts = await HTTPRequest.getRequest(this.endPoint + 'accounts/get_valid_accounts', null, null)
      accounts = accounts.sort((a, b) => {
        const textA = a.account_name.toUpperCase();
        const textB = b.account_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

      this.accounts = accounts || [];
    },

    async massUpdate(model, field_name, value){
      if (!this.selectedAccount) {
        this.$notification['error']({
          message: "Action Failed",
          description: "Please Choose an Account."
        });
        return;
      }

      let field_update = {}
      let response = {}
      let url = `${this.endPoint}/account_smcs/mass_update`;
      let categoryPayload = {
        account_id: this.selectedAccount,
        ids: this.checkedCategories,
        field_update: field_update
      }

      field_update[field_name] = value

      if(model == 'system_modules'){
        categoryPayload.ids = this.checkedValues
        url = `${this.endPoint}/account_system_modules/mass_update`
      }

      response = await HTTPRequest.postRequest(url, null, categoryPayload);

      if(response["message"] == "Ok"){
        this.$notification['success']({
          message: "Action Succesful",
          description: "Modules has been Updated. Please remind the users of the client to refresh the page for changes to take effect."
        });
      } else {
        this.$notification['error']({
          message: "Action Failed",
          description: "Please retry processing the changes again."
        });
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    async editModule(formId, system_module){
      if (!this.selectedAccount) {
        this.$notification['error']({
          message: "Action Failed",
          description: "Please Choose an Account."
        });
        return;
      }

      this.visible = true
      this.selectedModule = system_module
      this.configurationTitle = "Module Configuration - " + this.selectedModule.name
      const url = `${this.endPoint}account_system_modules/${this.selectedModule.id}?field_name=system_module_id&account_id=${this.selectedAccount}`;
      const accSystemModule = await HTTPRequest.getRequest(url, null)
      const metaData = JSON.parse(accSystemModule.meta)
      this.customFormMode = (metaData.form_mode == undefined || metaData.form_mode == null) ?  1 : this.customFormMode = metaData.form_mode

      if(this.customFormMode == 2){
        this.groups = metaData.customized_forms.groups
      } else if(this.customFormMode == 3)
        this.groups = metaData.customized_forms.groups_append

      this.groupsOverride = metaData.customized_forms.groups
      this.groupsAppend = metaData.customized_forms.groups_append

      this.dataSource = metaData.customized_fields
      this.formGroupStyle = metaData.customized_forms.mode

      this.refreshDataSet()
    },

    // Saving of Data
    async saveAccSystemModule(){
      let selectedModuleId = this.selectedModule.id
      let metaData = {}

      let completeField = false
      if(this.customFormMode == 2){
        if((_.intersection(this.existingConfig,this.requiredFields).length === this.requiredFields.length) == true) completeField = true

        metaData = {
          "account_system_module": {
            meta: JSON.stringify({
              form_mode: this.customFormMode,
              customized_fields: this.dataSource.sort((a, b) => parseInt(a.key) - parseInt(b.key)),
              customized_forms: {
                mode: this.formGroupStyle,
                groups: this.groups,
                groups_append: this.groupsAppend
              }
            })
          }
        }
      }
      else{
        completeField = true
        metaData = {
          "account_system_module": {
            meta: JSON.stringify({
              form_mode: this.customFormMode,
              customized_fields: this.dataSource.sort((a, b) => parseInt(a.key) - parseInt(b.key)),
              customized_forms: {
                mode: this.formGroupStyle,
                groups: this.groupsOverride,
                groups_append: this.groups
              }
            })
          }
        }
      }

      if(completeField){
        const url = `${this.endPoint}account_system_modules/${selectedModuleId}?field_name=system_module_id&account_id=${this.selectedAccount}`;
        let putRequest = await HTTPRequest.putRequest(url, null, metaData);
        this.visible = false
        this.current = 0
        this.dataSource = []
        this.component = {}
        this.group = {}
        this.groups = []
        this.viewMode = null
        this.$message['success'](
          "Configuration saved successfully."
        );
      } else {
        this.$message['error'](
          "Please make sure all system required fields are in your custom form."
        );
      }
    },
    // Form Editor
    setField(value){
      const target = this.modelAttributes.filter(item => value === item.field_name)[0];
      this.currentField = target
      Vue.set(this.component, 'label', this.currentField.label)
      Vue.set(this.component, 'required', this.currentField.required)

      switch(this.currentField.data_type) {
        case "integer":
          if(value.includes('_id')){
            Vue.set(this.component, 'type', "select")
            Vue.set(this.component, 'selectStyle', "2")
            let referenceModel = _.pluralize(value.split("_id")[0])
            Vue.set(this.component, 'endpoint', "/" + referenceModel + "/get_valid_" + referenceModel)
          }
          else
            Vue.set(this.component, 'type', "number")
          break;
        case "string":
          Vue.set(this.component, 'type', "text")
          break;
        case "boolean":
          Vue.set(this.component, 'type', "boolean")
          break;
        case "decimal":
          Vue.set(this.component, 'type', "number")
          break;
        case "datetime":
          Vue.set(this.component, 'type', "date")
          break;
      }
    },
    formBuilderClose(){
        this.formBuilderVisible = false
        this.group = {name: null, description: null}
    },
    async refreshDataSet(){
      if(this.customFormMode == 2){
        if(this.selectedModule.name == "Salesman"){
            this.modelAttributes = await HTTPRequest.getRequest(this.endPoint + 'salesmen/get_model_attributes', null)
          } else {
            const modelEndPoint = _.pluralize(_.snakeCase(this.selectedModule.name))
            this.modelAttributes = await HTTPRequest.getRequest(this.endPoint + modelEndPoint + '/get_model_attributes', null)
          }
          this.completeAttributes = this.modelAttributes
      }

      const customFields = [...this.dataSource]
      let customFieldsFormatted = []
      customFields.map(x => customFieldsFormatted.push({field_name: x.code, label: x.name, data_type: x.data_type}))

      const attributes = (this.customFormMode == 2) ? [...this.modelAttributes, ...customFieldsFormatted] : [...customFieldsFormatted]

      const attributeCodes = []
      attributes.map(item => attributeCodes.push(item["field_name"]))

      this.existingConfig = []
      for(let i = 0; this.groups.length > i; i++ ){
        let currentGroup = this.groups[i]
        if (currentGroup.terminalSettings != undefined){
          const codes = [...currentGroup.terminalSettings]
          codes.map(x => {
            if(attributeCodes.includes(x["code"]) == false){
              currentGroup.terminalSettings = codes.filter(item => item.code != x["code"])
            }else{
              this.existingConfig.push(x["code"])
            }
          })
        }
      }

      this.modelAttributes = attributes.filter(item => !this.existingConfig.includes(item.field_name));
    },
    async showFormBuilder(type, parameters=null){
      this.formBuilderVisible = true
      this.formBuilderType = type
      if(type == 'editGroup' || type == 'addComponents') this.group = parameters
      if(type == 'editComponent') {
        this.group = parameters.group
        this.component = parameters.component
      }
      if(type == 'addComponents') this.component = {}
      if (type == 'addComponents' || type == 'editComponent'){
        this.refreshDataSet()
      }
    },
    addGroup(){
      let groupKey = this.groups.length + 1
      let newGroup = {key: groupKey, sequence: groupKey, name: this.group.name, description: this.group.description}
      this.groups.push(newGroup)
      this.group = {name: null, description: null}
      this.formBuilderClose()
    },
    saveGroup(group){
      let objIndex = this.groups.findIndex((obj => obj.key == group.key));
      let updateGroup = this.groups[objIndex]
      updateGroup = group
      this.formBuilderClose()
    },
    deleteGroup(parameters){
      this.group = parameters.group
      const dataSource = [...this.groups];
      this.groups = dataSource.filter(item => item.key !== this.group.key);
    },
    reviewOptions(){
      if(this.component.selectStyle == 1){
        delete this.component.endpoint
      } else {
        delete this.component.options
        this.tableOptionKey
      }
    },
    addComponent(){
      let componentKey = 0
      if(this.group.terminalSettings == undefined){
          this.group.terminalSettings = []
          componentKey = 1
      } else {
          componentKey = this.group.terminalSettings.length + 1
      }

      let newComponent = this.component
      let valid = false

      if(newComponent["code"] != undefined || newComponent["type"] != undefined || newComponent["label"] != undefined){
        if(newComponent["type"] == 'select' || newComponent["type"] == 'multiple_select' || newComponent["type"] == 'cascader' || newComponent["type"] == 'radio'){
          if(newComponent["options"] != undefined && newComponent["options"] != [] ){
            valid = true
          }else{
            if (newComponent["endpoint"] != undefined && (newComponent["endpoint"] != null || newComponent["endpoint"] != "") ){
              valid = true
            }
          }
        } else {
          valid = true
        }
      }

      if(valid == true){
        newComponent["key"] = componentKey
        this.group.terminalSettings.push(newComponent)
        this.component = {}
        this.refreshDataSet()
        this.formBuilderClose()
        this.componentsTableKey++
      } else {
        this.$message['error']("Cannot save. Please validate your inputs.");
      }
    },
    saveComponent(component){
      let objIndex = this.group.terminalSettings.findIndex((obj => obj.key == component.key));
      let updateComponent = this.group.terminalSettings[objIndex]
      let newComponent = component;
      let valid = false

      if(newComponent["code"] != undefined || newComponent["type"] != undefined || newComponent["label"] != undefined){
        if(newComponent["type"] == 'select' || newComponent["type"] == 'multiple_select' || newComponent["type"] == 'cascader' || newComponent["type"] == 'radio'){
          if(newComponent["options"] != undefined && newComponent["options"] != [] ){
            valid = true
          }else{
            if (newComponent["endpoint"] != undefined && (newComponent["endpoint"] != null || newComponent["endpoint"] != "") ){
              valid = true
            }
          }
        } else {
          valid = true
        }
      }

      if(valid == true){
        updateComponent = component
        this.formBuilderClose()
        this.componentsTableKey++
      } else {
        this.$message['error'](
          "Cannot save. Please validate your inputs."
        );
      }


    },
    deleteComponent(parameters){
      this.group = parameters.group
      this.component = parameters.component
      const dataSource = [...this.group.terminalSettings];
      this.group.terminalSettings = dataSource.filter(item => item.key !== this.component.key);
      this.refreshDataSet()
    },
    // Custom Fields
    handleAdd(type=null) {
      //const { count } = this;
      if(type == null){
        const { dataSource } = this;
        if(dataSource.length > 0){
          let ds = dataSource.slice().sort((a, b) => parseInt(a.key) - parseInt(b.key))
          this.count = ds[ds.length - 1].key + 1
        }else {
          this.count = 0
        }

        const newData = { key: this.count,  code: "", name: "", editable: true};
        let newDs = [...dataSource,newData];
        this.dataSource = newDs;
        let page = Math.ceil(this.dataSource.length / 10) || 1;
        this.dataSourcepagination.current = page;
      } else if (type == 'options') {
        let options = []
        if (this.component.options != undefined){
          options = this.component.options
          if(this.component.options.length > 0){
            this.count = this.component.options[this.component.options.length - 1].key + 1
          }else {
            this.count = 0
          }
        } else {
          this.count = 0
        }
        const newData = { key: this.count,  id: "", name: "", editable: true};
        this.component.options = [...options, newData]
        this.tableOptionKey++
      } else {
        let conditions = []
        if (this.component.conditions != undefined){
          conditions = this.component.conditions
          if(this.component.conditions.length > 0){
            this.count = this.component.conditions[this.component.conditions.length - 1].key + 1
          }else {
            this.count = 0
          }
        } else {
          this.count = 0
        }

        const newData = { key: this.count,  code: "", operator: "", value: "", editable: true};
        this.component.conditions = [...conditions, newData]
        this.tableConditionKey++
      }
      //this.count++;

    },
    handleChange(value, key, column, type=null) {
      if(type == null){
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.dataSource = newData;
        }
      } else if (type == 'options') {
        const newData = [...this.component.options];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.component.options = newData;
        }
      } else {
        const newData = [...this.component.conditions];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.component.conditions = newData;
        }
      }
    },
    edit(key, type=null) {
      if(type == null){
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.dataSource = newData;
        }
      } else if (type == 'options') {
        const newData = [...this.component.options];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.component.options = newData;
          this.tableOptionKey++
        }
      } else {
        const newData = [...this.component.conditions];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.component.conditions = newData;
          this.tableConditionKey++
        }
      }

    },
    save(key, type=null) {
      if(type == null){
        const newData = [...this.dataSource];
        const defNewData = [...this.completeAttributes];
        const target = newData.filter(item => key === item.key)[0];

        if (!target) { return; }

        if( (target.name == null || target.name == '') ||  (target.code == null || target.code == '')){
          this.$message['error']("Cannot save. Null values.");
        } else {
          const dupCode = newData.filter(item => target.name === item.name).length;
          const dupName = newData.filter(item => target.code === item.code).length;
          const defDupCode = defNewData.filter(item => target.code === item.field_name).length;
          const defDupName = defNewData.filter(item => target.name === item.label).length;
          if(dupCode > 1 || dupName > 1 || defDupCode > 0 || defDupName > 0){
            this.$message['error']("Cannot save. Duplicate value.");
          } else {
            delete target.editable;
            this.dataSource = newData;
            Object.assign(
              target
            );
          }
        }
      } else if (type == 'options') {
        const newData = [...this.component.options];
        const target = newData.filter(item => key === item.key)[0];
        if(target){
          delete target.editable;
          this.component.options = newData;
          Object.assign(
            target
          );
          this.tableOptionKey++
        }
      } else {
        const newData = [...this.component.conditions];
        const target = newData.filter(item => key === item.key)[0];
        if(target){
          delete target.editable;
          this.component.conditions = newData;
          Object.assign(
            target
          );
          this.tableConditionKey++
        }
      }
    },
    deleteField(record, type=null) {
        if(type == null){
            const dataSource = [...this.dataSource];
            this.dataSource = dataSource.filter(item => item.key !== record.key);
            this.refreshDataSet()
        } else if (type == 'options') {
            const dataSource = [...this.component.options];
            this.component.options = dataSource.filter(item => item.key !== record.key);
            this.tableOptionKey++
        } else {
          const dataSource = [...this.component.conditions];
          this.component.conditions = dataSource.filter(item => item.key !== record.key);
          this.tableConditionKey++
        }
    },
    cancel(key, type=null){
      if(type == null){
        const newData = [...this.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          delete target.editable;
          this.dataSource = newData;
          Object.assign(
            target
          );
        }
      }
    },

    // CHECKBOX MODULES
    onCheckChange(e){
      if(this.checkedValues.includes(e)){
        let indexValue = this.checkedValues.indexOf(e)
        this.checkedValues.splice(indexValue,1)
      } else {
        this.checkedValues.push(e)
      }
    },
    onCheckAllChange(){
      if(this.checkedValues.length == this.system_modules.length){
        this.checkedValues = []
      } else {
        this.checkedValues = this.system_modules.map(value => value.id)
      }
    },

    //CHECKBOX SYSTEM ACCESS
    onCheckChangeAccess(e){
      if(this.selectedAccessRights.includes(e)){
        let indexValue = this.selectedAccessRights.indexOf(e)
        this.selectedAccessRights.splice(indexValue,1)
      } else {
        this.selectedAccessRights.push(e)
      }
    },

    clearData(){
      this.current = 0
      this.component = {}
      this.group = {}
      this.dataSource = []
      this.groups = []
      this.viewMode = null
      this.configKey++;
    },

    onClose() {
      this.visible = false
      this.clearData()
    },

    // TREE FUNCTIONS
    onExpand (expandedKeys) {
      this.selectedNode = null
      this.clearData()
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      const value = e.target.value
      const expandedKeys = dataList.map((item) => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, gData)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      })
    },
    onCheck(info){
        this.checkedCategories = info
    },
    async onSelect(info){
      let selectedNode = getNode(info[0], gData)
      this.selectedNode = selectedNode
      this.selectedKey = selectedNode.key
      this.selectedCode = selectedNode.scopedSlots.code
      this.selectedRefCode = selectedNode.scopedSlots.reference_code
      this.selectedSequence = selectedNode.scopedSlots.sequence_no
      this.selectedIcon = selectedNode.scopedSlots.icon
      this.selectedEndpoint = selectedNode.scopedSlots.endpoint
      this.selectedLevel = selectedNode.scopedSlots.category_level
      this.selectedTitle = selectedNode.title
      this.checkedValues = []
      if(selectedNode.children.length == 0){
        let system_modules = await HTTPRequest.getRequest(this.endPoint + '/system_modules?system_module_category_id=' + this.selectedKey + "&status=A" , null)
        this.system_modules = system_modules
      } else {
        this.system_modules = []
      }
    },
    onDragEnter (info) {
      // eslint-disable-next-line
      // eslint-disable-next-line
    },
    async onDrop (info) {
      let for_update = info.dragNode.$options.propsData.eventKey
      let new_parent = info.node.$options.propsData.eventKey
      let categoryPayload = {system_module_category: {parent_id: new_parent} }
      this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_module_categories/' + for_update , null, categoryPayload)
      gData = this.gData
      generateList(gData)
    },
  },
}
</script>

<style>
</style>


